export function isWorldBounds(bounds) {
    return Boolean(
        bounds &&
            bounds.sw?.lat <= -85 &&
            bounds.ne?.lat >= 85 &&
            bounds.sw?.lon <= -180 &&
            bounds.ne?.lon >= 180
    );
}

export function isBoundsOnlyFilters(filters) {
    const location = filters?.location;
    return Boolean(location?.bounds?.sw && location?.bounds?.ne && !location?.polygon?.location_id);
}

// A member-framed map area; the default world-wide search is not one.
export function isMapAreaFilters(filters) {
    return isBoundsOnlyFilters(filters) && !isWorldBounds(filters.location.bounds);
}
